import React from 'react'
import Navbar from '../shared/Navbar'
import Banner1 from './Banner1'
import Banner3 from './Banner3'
import Banner2 from './Banner2'
import CarouselModule from '../shared/Carousel'
import img1 from '../assets/images/Restaurant/WebP/1.webp'
import img2 from '../assets/images/Restaurant/WebP/2.webp'
import img3 from '../assets/images/Restaurant/WebP/3.webp'
import img4 from '../assets/images/Restaurant/WebP/4.webp'
import img5 from '../assets/images/Endi Coffee & Bakery Shop/WebP/1.webp'
import img6 from '../assets/images/Endi Coffee & Bakery Shop/WebP/2.webp'
import img7 from '../assets/images/Endi Coffee & Bakery Shop/WebP/3.webp'
import img8 from '../assets/images/Endi Coffee & Bakery Shop/WebP/4.webp'
import img9 from '../assets/images/VM INTERIOR/WebP/1.webp'
import img10 from '../assets/images/VM INTERIOR/WebP/2.webp'
import img11 from '../assets/images/VM INTERIOR/WebP/3.webp'
import img12 from '../assets/images/VM INTERIOR/WebP/4.webp'
import img13 from '../assets/images/ARNISI/WebP/1.webp'
import img14 from '../assets/images/ARNISI/WebP/2.webp'
import img15 from '../assets/images/ARNISI/WebP/3.webp'
import img16 from '../assets/images/ARNISI/WebP/4.webp'
import Footer from '../Footer/footer'

export default function Home() {
    const data = [
        {img: img1,},
        {img: img2,},
        {img: img3,},
        {img: img4,},
        {img: img5,},
        {img: img6,},
        {img: img7,},
        {img: img8,},
        {img: img9,},
        {img: img10,},
        {img: img11,},
        {img: img12,},
        {img: img13,},
        {img: img14,},
        {img: img15,},
        {img: img16,}
      ]
  return (
    <div className='w-full overflow-hidden'>
        <Navbar/>
        <Banner1/>
        <Banner3/>
        <Banner2/>
        <CarouselModule tittle="Our Projects" data={data}/>
        <Footer/>
    </div>
  )
}
